import {defineType} from 'sanity'
import {ComponentPreview} from './ComponentPreview'
import {MdOutlineDirectionsBoatFilled} from 'react-icons/md'

export default defineType({
  type: 'object',
  name: 'related-cruises',
  title: 'Related Cruises',
  icon: MdOutlineDirectionsBoatFilled,
  components: {
    preview: (props) => <ComponentPreview {...props} />,
  },
  fields: [
    {
      name: 'title',
      type: 'string',
      title: 'Title',
    },
    {
      name: 'ctaButtons',
      type: 'ctaButtons',
    },
    {
      name: 'filters',
      type: 'fyc-filters',
      title: 'Cruise Filters',
      description: 'Optionally add filters to narrow down the cruise search results.',
    },
  ],
  preview: {
    select: {
      title: 'title',
      subtitle: 'content',
      media: 'image',
    },
  },
})
